import { Controller } from "@hotwired/stimulus"

// Hides the account/CCCD/mobile inputs when the selected bank collects nothing
// from us (VnBank::TINGEE_NO_ACCOUNT_FIELDS — e.g. TPBank, where the owner picks
// the account on the bank's own web). Hidden inputs also drop `required` so the
// browser doesn't block submit on invisible fields.
//
// The bank picker is a ui--searchable-select, which commits into a hidden field
// (name="bank_code") and fires a bubbling `change` on it — so we read the value
// from that hidden field rather than a native <select>.
export default class extends Controller {
  static targets = ["fields"]
  static values = { noFieldBanks: Array }

  connect() {
    this.hidden = this.element.querySelector('input[type="hidden"][name="bank_code"]')
    this.onChange = () => this.apply()
    this.hidden?.addEventListener("change", this.onChange)
    this.apply()
  }

  disconnect() {
    this.hidden?.removeEventListener("change", this.onChange)
  }

  apply() {
    const hidden = this.noFieldBanksValue.includes(this.hidden?.value)
    this.fieldsTarget.hidden = hidden
    this.fieldsTarget.querySelectorAll("input").forEach((input) => (input.required = !hidden))
  }
}
